import React from 'react';
import strategyIcon from '../assets/services/strategy.png';
import organizationIcon from '../assets/services/organization.png';
import processIcon from '../assets/services/process.png';
import publicIcon from '../assets/services/public-sector.png';
import digitalIcon from '../assets/services/digital.png';

function Services() {
  const services = [
    {
      icon: strategyIcon,
      title: 'Management Consulting',
      subtitle: '경영전략',
      description: '비즈니스의 지속 가능한 성장과 미래 방향성을 제시합니다.',
      items: [
        '중장기 경영전략(Vision & Strategy) 수립',
        '경영혁신 및 운영체계(Operating Model) 개선',
        '신사업 계획 및 실행 전략 수립',
        '공공기관 경영평가 대응 및 자문'
      ]
    },
    {
      icon: organizationIcon,
      title: 'Organization & HR Design',
      subtitle: '조직 및 인력 설계',
      description: '전략을 실행하는 최적의 조직 구조와 인력 역량을 설계합니다.',
      items: [
        '조직 진단 및 역량 분석',
        '기능 및 업무 프로세스 분석',
        '적정 인력 산정(Workforce Sizing)',
        '조직 구조 재설계(Restructuring)',
        '직무 분석 및 역할 체계 구축'
      ]
    },
    {
      icon: processIcon,
      title: 'Process Innovation',
      subtitle: '프로세스 혁신',
      description: '비즈니스 효율성을 극대화하는 최적의 운영 시스템을 구축합니다.',
      items: [
        'End-to-End 업무 프로세스 분석 및 진단',
        '프로세스 최적화 및 업무 효율화(PI)',
        '성과관리 체계(KPI) 구축 및 모니터링',
        '운영 및 유지관리 체계 고도화'
      ]
    },
    {
      icon: publicIcon,
      title: 'Public Sector & Research',
      subtitle: '공공 컨설팅 및 정책 연구',
      description: '공공의 가치를 실현하는 합리적인 정책과 실행 기반을 마련합니다.',
      items: [
        '정부 및 공공기관 정책 연구 과제 수행',
        '신규 사업 타당성 검토 및 분석',
        '공공 서비스 운영 실태 분석 및 개선',
        '맞춤형 조사·분석 연구'
      ]
    },
    {
      icon: digitalIcon,
      title: 'Digital Solutions',
      subtitle: '디지털 솔루션',
      description: '최신 기술과 데이터를 기반으로 비즈니스의 디지털 가치를 창출합니다.',
      items: [
        '생성형 AI 활용 및 비즈니스 적용 컨설팅',
        '데이터 기반 분석 및 인사이트 도출',
        '디지털 전환(DX) 전략 수립 및 실행 지원',
        '디지털 플랫폼 기획 및 아키텍처 설계',
        '정보시스템 구축(SI) 전략 및 PMO 지원'
      ]
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Business Services</h2>
          <div className="title-underline"></div>
          <p className="section-description">
            유니원솔루션은 기업의 전략부터 조직, 프로세스, 디지털 전환에 이르기까지<br/>
            비즈니스의 전 여정을 아우르는 통합 컨설팅 서비스를 제공합니다.
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <img src={service.icon} alt={service.subtitle} />
              </div>
              <p className="service-subtitle">{service.subtitle}</p>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-list">
                {service.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <a href="#contact" className="service-link">자세히 보기 →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
